// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post } from "./api_client";
import { FacilityEventType } from "../models";
import { FacilityEventResult, IFacilityEventResult, OrganizationEventLookup, IOrganizationEventLookup, FacilityEvent, IFacilityEvent, EventReviewRequest, IEventReviewRequest } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getByOrganization(organizationId?: string, limit?: number, sortKey?: string, sortDirection?: string, eventType?: FacilityEventType, deviceId?: string, facilityId?: string, trigger?: string, eventValue?: number, dateFrom?: Date, dateTo?: Date, cursor?: string, includeTargetHistory?: boolean, includeInvalid?: boolean): ApiResult<FacilityEventResult> {
		const queryParams = [limit !== undefined ? `limit=${limit}` : undefined,
			sortKey !== undefined ? `sortKey=${sortKey}` : undefined,
			sortDirection !== undefined ? `sortDirection=${sortDirection}` : undefined,
			eventType !== undefined ? `eventType=${eventType}` : undefined,
			deviceId !== undefined ? `deviceId=${deviceId}` : undefined,
			facilityId !== undefined ? `facilityId=${facilityId}` : undefined,
			trigger !== undefined ? `trigger=${trigger}` : undefined,
			eventValue !== undefined ? `eventValue=${eventValue}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined,
			cursor !== undefined ? `cursor=${cursor}` : undefined,
			includeTargetHistory !== undefined ? `includeTargetHistory=${includeTargetHistory}` : undefined,
			includeInvalid !== undefined ? `includeInvalid=${includeInvalid}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IFacilityEventResult>(`/api/organizationevent/by_organization/${ organizationId }${query}`).then(result => result === undefined ? undefined :  new FacilityEventResult(result));
}

export async function getById(eventId?: string): ApiResult<OrganizationEventLookup> {
	return get<IOrganizationEventLookup>(`/api/organizationevent/${ eventId }`).then(result => result === undefined ? undefined :  new OrganizationEventLookup(result));
}

export async function getCountByOrganization(organizationId?: string, eventType?: FacilityEventType, deviceId?: string, facilityId?: string, trigger?: string, eventValue?: number, dateFrom?: Date, dateTo?: Date, includeInvalid?: boolean): ApiResult<number> {
		const queryParams = [eventType !== undefined ? `eventType=${eventType}` : undefined,
			deviceId !== undefined ? `deviceId=${deviceId}` : undefined,
			facilityId !== undefined ? `facilityId=${facilityId}` : undefined,
			trigger !== undefined ? `trigger=${trigger}` : undefined,
			eventValue !== undefined ? `eventValue=${eventValue}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined,
			includeInvalid !== undefined ? `includeInvalid=${includeInvalid}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<number>(`/api/organizationevent/by_organization/${ organizationId }/count${query}`);
}

export async function reviewEvent(organizationId?: string, eventId?: string, request?: EventReviewRequest): ApiResult<FacilityEvent> {
	return post<IFacilityEvent>(`/api/organizationevent/by_organization/${ organizationId }/${ eventId }/review`, request).then(result => result === undefined ? undefined :  new FacilityEvent(result));
}
